import React, { useState } from 'react';
import { SearchPropertyProps } from '../layout/table/property/Property.types';

export function useSearch({ initialValue, onChange }: SearchPropertyProps) {
    const [value, setValue] = useState<string>(initialValue!);

    function handleValueChange(event: React.ChangeEvent<HTMLInputElement>) {
        const value = event.target.value;

        setValue(value);
        onChange && onChange(value);
    }

    return { value, handleValueChange }
}